/**
 * Requirements shown under the password field while the user types. The ids map
 * to translation keys, so the copy stays in the message catalogue.
 */
export const PASSWORD_RULES = [
  { id: "minLength", test: (value: string) => value.length >= 8 },
  {
    id: "letterCase",
    test: (value: string) => /\p{Ll}/u.test(value) && /\p{Lu}/u.test(value),
  },
  {
    id: "specialOrDigit",
    test: (value: string) => /[\d\p{P}\p{S}]/u.test(value),
  },
] as const;

export type PasswordRuleId = (typeof PASSWORD_RULES)[number]["id"];

export const getUnmetPasswordRules = (value: string): PasswordRuleId[] =>
  PASSWORD_RULES.filter((rule) => !rule.test(value)).map((rule) => rule.id);

export const isPasswordValid = (value: string) =>
  getUnmetPasswordRules(value).length === 0;
